export default {
  label: 'Enviar para',
  counter: '{{current}} de {{max}}',
  default_badge: 'Predefinido',
  remove: 'Remover {{email}}',
  add_back: 'Adicionar novamente',
  empty: 'Adicione pelo menos um e-mail.',
  add_label: 'Adicionar um e-mail',
  placeholder: 'nome@exemplo.com',
  add: 'Adicionar',
  hint: 'Até {{max}} e-mails. Cada um recebe o seu próprio e-mail.',
  hint_full: 'Este é o máximo que a lista pode ter. Remova um e-mail para adicionar outro.',
  errors: {
    full: 'Pode adicionar no máximo {{max}} e-mails.',
    invalid: 'Introduza um e-mail como nome@exemplo.com.',
    duplicate: '{{email}} já está na lista.',
  },
};
